<template>
  <section
    id="recent-projects"
    class="hide-overflow"
  >
    <v-layout>
      <v-flex
        xs12
        md6
        primary
        text-xs-center
        pa-5
        white--text
      >
        <base-bubble-1
          style="transform: rotate(180deg) translateX(25%)"
        />
        <base-heading>
          Works
        </base-heading>

        <base-text class="mb-5">
          Private works.
        </base-text>

        <v-card color="secondary">
          <v-container
            grid-list-md
            pa-2
          >
            <v-layout wrap>
              <v-flex
                v-for="(project, i) in projects"
                :key="i"
                xs12
                md6
              >
                <a :href="project.url">
                  <v-img
                    :src="require(`@/assets/${project.image}`)"
                    max-height="300"
                  />
                </a>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="require('@/assets/outdoor-fuji.jpg')"
          height="100%"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data: () => ({
    projects: [
      {
        url: 'https://baiken.st40.xyz',
        title: 'BAIKEN',
        image: 'baiken.jpg'
      },
      {
        url: 'https://pab.st40.xyz',
        title: 'P-Arts Board',
        image: 'pab.jpg'
      },
      {
        url: 'https://etoget.st40.xyz',
        title: 'EtoGet Game App',
        image: 'etoget.jpg'
      },
      {
        url: 'https://oar-analytics.st40.xyz/2020/',
        title: 'OAR Analytics 2020',
        image: 'analytics.jpg'
      },
      {
        url: 'https://example.st40.xyz/leaflet-sample/esri.html',
        title: 'Leaflet',
        image: 'map.jpg'
      },
      {
        url: 'https://oar.st40.xyz',
        title: 'OAR STYLE',
        image: 'oar-style.jpg'
      },
      {
        url: 'https://code.st40.xyz',
        title: 'OAR CODE',
        image: 'oar-code.jpg'
      },
      {
        url: 'https://code.st40.xyz/article/1070',
        title: 'OAR ADMIN',
        image: 'oar-admin.jpg'
      }
    ]
  })
}
</script>
